<template>
  <BTable
    v-bind="$attrs"
    :list="list"
    :selected="value"
    :headers="headersComputed"
    :actions="actions"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.name="{ header, item }">
      <router-link
        v-if="hasAccessToGroups"
        :to="header.getRoute(item)"
        v-text="item.name"
      />
      <span v-else v-text="item.name" />
    </template>

    <template #item.permissions="{ value: v }">
      <BCollapser
        v-if="v"
        :list="v"
        :min-height-by-count="2"
      />
    </template>

    <template #item.ates="{ value: v }">
      <BCollapser
        v-if="v"
        :list="v"
        :min-height-by-count="2"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/Groups/table-headers'
import { authGroupPermissions as Permissions } from '@/helpers/enums/permission-models'

import BTable from '@/components/common/BTable.vue'
import BCollapser from '@/components/common/BCollapser.vue'


export default {
  name: 'BTablePermissionGroups',
  components: {
    BTable,
    BCollapser,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    list: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
  computed: {
    hasAccessToGroups() {
      return this.$access(Permissions.read)
    },
    headersComputed() {
      const { headers, list } = this

      const item = list?.[0]
      if (!item) return headers
      const keys = Object.keys(item)

      return headers.filter((_) => keys.includes(_.value))
    },
  },
}
</script>
